// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js","322":"component---src-templates-corpus-js"}[chunkId] || chunkId) + "-" + {"125":"d824084f84db68d44f6d","293":"2957809c4d13faf58be1","322":"e909de7f5d8199cf5abe","522":"b494abcc451c1e618820"}[chunkId] + ".js";
};